import { CustomTypographyComponentProps } from "../types";
import { Typography } from "@mui/material";

export const Body1Typography = ({
  children,
  ...props
}: CustomTypographyComponentProps) => {
  return (
    <Typography variant="body1" {...props}>
      {children}
    </Typography>
  );
};
